import { render, staticRenderFns } from "./PendingItemSummary.vue?vue&type=template&id=47df6430&scoped=true&"
import script from "./PendingItemSummary.vue?vue&type=script&lang=js&"
export * from "./PendingItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./PendingItemSummary.vue?vue&type=style&index=0&id=47df6430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df6430",
  null
  
)

export default component.exports